import { useCallback } from 'react'
import { PostStatus } from '@global/types'

export const useTargets = () => {
  const getTargetStatus = useCallback(datasetPosts => {
    const statuses = datasetPosts
      ?.map(post => {
        if (PostStatus.complete === post.status.toLowerCase()) return true
      })
      .filter(v => v)

    return {
      success: statuses?.length,
      total: datasetPosts?.length,
    }
  }, [])

  return {
    getTargetStatus,
  }
}
